//头部
<template>
  <div
    :class="{notchHeader:hasNotch, header:true,xHeader:$store.state.iphonex,flexElement:true, weHeader:$store.state.wechat}"
    v-show="!$store.state.wechat"
  >
    <span  class="aside asideLeft" @click="showBack ? $router.goBack():''">
      <van-icon   :name="showBack?  'arrow-left':''" size="20px" />
    </span>
    <span>{{title}}</span>
    <span
      class="aside"
      v-if="showHome || showShare || showOption || showLocation"
      @click="_onClick"
    >
      <img v-if="showHome" src="../../../static/icon/icon/icon_home.png" alt class="homeIcon" width="20px" style="margin-top:3px"/>
      <span class="flexAlign rightIcon" v-if="showShare">
        <img
          :src="collect ? '../../../static/icon/icon/icon_like_pre.png' : '../../../static/icon/icon/icon_like_pre2.png'"
          alt
          class="otherIcon"
          @click.stop="changeCollect"
        />
        <!-- <img src="../../../static/icon/icon/icon_share.png" alt="" class='otherIcon end'> -->
      </span>
      <van-icon v-if="showOption" name="setting-o" size="2em" />
      <span class="flexElement" v-if="showLocation  && !window_hospitalCode">
        <img src="../../../static/icon/icon/icon_location_1.png" alt class="iconLocation" />韩城市
      </span>
    </span>
    <span class="aside" v-else></span>
  </div>
</template>
<script>
import { AppOperate } from '@/utils/appfunc'
export default {
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '首页'
    },
    showHome: {
      type: Boolean,
      default: true
    },
    showShare: {
      type: Boolean,
      default: false
    },
    showOption: {
      type: Boolean,
      default: false
    },
    showLocation: {
      type: Boolean,
      default: false
    },
    collect: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      hasNotch: false,
      window_hospitalCode:window.HOSPITAL_CODE
    }
  },
  methods: {
    _onClick () {
      if (this.showHome) {
        this.navigate_pop1()
        if (!!window.HOSPITAL_CODE) {
          this.$router.replaceto({
            path: '/hospital/index', query: {
              hospitalCode: window.HOSPITAL_CODE,
              hospitalName: window.HOSPITAL_NAME
          } })
        } else {
          this.$router.replaceto({ path: '/index' })
        }
        
      } else if (this.showShare) {
      } else if (this.showOption) {
        this.$router.goto({ path: '/setting' })
      }
    },
    changeCollect () {
      this.$emit('changeCollect')
    }
  },
  created () {
    this.$store.commit('changeHeaderTitle', this.title)
    AppOperate.getNotchPhone(res => {
      res = JSON.parse(res)
      if (res.hasNotch === true) {
        this.hasNotch = true
      }
      console.log(this.hasNotch)
    })
  }
}
</script>
<style lang="less" scoped>
.header {
  background-color: #fff;
  .h(64);
  .padding(33, 15, 15, 15);
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 998;
  .fs(18);
  text-align: center;
  color: @mainTitle;

  .iconLocation {
    .w(16);
    .h(16);
  }
  .otherIcon {
    .w(24);
    .h(24);
  }
  .aside {
    .w(65);
    .fs(14);
    text-align: right;
  }
  .asideLeft {
    text-align: left;
  }
  .rightIcon {
    float: right;
    .end {
      .margin(0, 0, 0, 18);
    }
  }
}
.xHeader {
  .h(88);
  .padding(57, 15, 0, 15);
}
.notchHeader {
  .h(70);
  .padding(57, 15, 15, 15);
}

.weHeader {
  .h(0);
  .padding(0, 15, 0, 15);
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue